import { getSetting } from './settings.js';

const COLORS = ['#22c55e', '#5b8def', '#f59e0b', '#ef4444', '#a78bfa', '#06b6d4'];

let canvas;
let ctx;
let particles = [];
let raf;

function ensureCanvas() {
  if (typeof window === 'undefined') return null;
  if (canvas) return canvas;
  canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;';
  document.body.appendChild(canvas);
  ctx = canvas.getContext('2d');
  resize();
  window.addEventListener('resize', resize);
  return canvas;
}

function resize() {
  if (!canvas) return;
  const dpr = window.devicePixelRatio || 1;
  canvas.width = window.innerWidth * dpr;
  canvas.height = window.innerHeight * dpr;
  ctx.scale(dpr, dpr);
}

function spawnParticle(x, y) {
  const angle = (Math.random() - 0.5) * Math.PI * 0.8 - Math.PI / 2;
  const speed = 6 + Math.random() * 8;
  return {
    x,
    y,
    vx: Math.cos(angle) * speed * (1 + Math.random() * 0.5),
    vy: Math.sin(angle) * speed,
    rot: Math.random() * Math.PI * 2,
    vr: (Math.random() - 0.5) * 0.3,
    color: COLORS[(Math.random() * COLORS.length) | 0],
    size: 6 + Math.random() * 6,
    life: 1
  };
}

function tick() {
  if (!ctx || !canvas) return;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  for (const p of particles) {
    p.x += p.vx;
    p.y += p.vy;
    p.vy += 0.32;
    p.vx *= 0.99;
    p.rot += p.vr;
    p.life -= 0.008;
    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate(p.rot);
    ctx.globalAlpha = Math.max(0, p.life);
    ctx.fillStyle = p.color;
    ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
    ctx.restore();
  }
  particles = particles.filter(p => p.life > 0 && p.y < window.innerHeight + 50);
  if (particles.length > 0) {
    raf = requestAnimationFrame(tick);
  } else {
    cancelAnimationFrame(raf);
    raf = null;
    if (canvas) ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
}

export function fireConfetti(opts = {}) {
  if (!getSetting('confetti')) return;
  ensureCanvas();
  const count = opts.count ?? 80;
  const sources = [
    { x: window.innerWidth * 0.25, y: window.innerHeight * 0.7 },
    { x: window.innerWidth * 0.75, y: window.innerHeight * 0.7 }
  ];
  for (let i = 0; i < count; i++) {
    const src = sources[i % sources.length];
    particles.push(spawnParticle(src.x, src.y));
  }
  if (!raf) tick();
}
